import { z } from "zod";
import { Confidence, DateISO, DueType, Effort, Priority, SourceKind, SourceStatus } from "../enums.js";
import { UserSummary } from "./user.js";
export const Source = z.object({
    id: z.string().uuid(),
    project_id: z.string().uuid().nullable(),
    project_name: z.string().nullable(),
    kind: SourceKind,
    title: z.string().nullable(),
    url: z.string().nullable(),
    mime_type: z.string().nullable(),
    size_bytes: z.number().nullable(),
    has_file: z.boolean(),
    digest: z.string().nullable(),
    status: SourceStatus,
    error: z.string().nullable(),
    submitted_by: UserSummary.nullable(),
    comment: z.string().nullable(),
    /** Present when status is needs_review: what the AI proposed. */
    proposal: z
        .object({
        target_kind: z.enum(["existing", "new", "unclear", "not_project_related"]),
        project_id: z.string().uuid().nullable(),
        confidence: Confidence,
        rationale: z.string(),
        alternatives: z.array(z.object({ project_id: z.string(), why: z.string() })),
        new_project_name: z.string().nullable(),
        candidate_step_count: z.number().int(),
        candidate_task_count: z.number().int(),
    })
        .nullable(),
    created_at: z.string(),
    processed_at: z.string().nullable(),
});
export const IntakeJsonInput = z.object({
    text: z.string().max(200_000).optional(),
    url: z.string().url().optional(),
    title: z.string().max(300).optional(),
    comment: z.string().max(2000).optional(),
    project_id: z.string().uuid().optional(),
    client_id: z.string().max(80).optional(),
});
export const IntakeResponse = z.object({
    sources: z.array(z.object({ id: z.string().uuid(), status: SourceStatus })),
});
export const ResolveSourceInput = z.object({
    action: z.enum(["assign", "create_project", "discard"]),
    project_id: z.string().uuid().optional(),
});
/** What the intake model returns for one dropped item. */
export const IntakeDecision = z.object({
    title: z.string(),
    digest: z.string(),
    target: z.object({
        kind: z.enum(["existing", "new", "unclear", "not_project_related"]),
        project_id: z.string().nullable(),
        confidence: Confidence,
        rationale: z.string(),
        alternatives: z.array(z.object({ project_id: z.string(), why: z.string() })),
    }),
    new_project: z
        .object({
        name: z.string(),
        summary: z.string(),
        kind: z.enum(["client", "venture", "internal", "other"]),
        tags: z.array(z.string()),
        repo_url: z.string().nullable(),
    })
        .nullable(),
    candidate_steps: z.array(z.object({
        title: z.string(),
        description: z.string(),
        suggested_due: DateISO.nullable(),
        due_type: DueType,
        is_milestone: z.boolean(),
        confidence: Confidence,
    })),
    candidate_tasks: z.array(z.object({
        title: z.string(),
        details: z.string(),
        step_title: z.string().nullable(),
        assignee_hint: z.string().nullable(),
        due_date: DateISO.nullable(),
        due_type: DueType,
        priority: Priority,
        effort: Effort.nullable(),
        confidence: Confidence,
    })),
    overall_confidence: Confidence,
});
export const Notification = z.object({
    id: z.string().uuid(),
    kind: z.enum(["intake", "review", "health", "report", "assignment", "mention"]),
    title: z.string(),
    body: z.string(),
    data: z.record(z.string(), z.unknown()),
    read_at: z.string().nullable(),
    created_at: z.string(),
});
//# sourceMappingURL=source.js.map